import request from './axios'

// --- 认证与用户 ---
export const login = (username, password) => {
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  return request.post('/auth/login', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const changePassword = (data) => request.post('/user/change_password', data)
export const getUserInfo = () => request.get('/user/info')

// --- 文件上传 ---
export const uploadFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/upload/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// --- 单页面模板管理 ---
export const getTemplateList = () => request.get('/single_page/template/list')
export const saveTemplate = (data) => request.post('/single_page/template/update', data)
export const createTemplate = (data) => request.post('/single_page/template', data)

// --- 单页面管理 ---
export const getSinglePageList = () => request.get('/single_page/page/list')
export const getSinglePageDetail = (id) => request.get(`/single_page/page/detail/${id}`)
export const saveSinglePage = (data) => request.post('/single_page/page/update', data)
export const togglePageStatus = (master_id) => request.post(`/single_page/page/toggle_hide/${master_id}`)

// --- 新闻分类管理 ---
export const getNewsCategoryTree = () => request.get('/news/category/list')
export const saveNewsCategory = (data) => request.post('/news/category/update', data)
export const createNewsCategory = (data) => request.post('/news/category', data)
export const deleteNewsCategory = (data) => request.post('/news/category/delete', data)
export const updateNewsCategoryStatus = (data) => request.post('/news/category/status', data)

// 获取新闻列表（后台管理用）
export const getNewsList = (params) => request.get('/news/list', { params })
export const getNewsDetail = (master_id) => request.get(`/news/detail/${master_id}`)
export const saveNews = (data) => request.post('/news/save', data)
export const deleteNews = (master_id) => request.post(`/news/delete/${master_id}`)
export const toggleHideNews = (master_id) => request.post(`/news/toggle_hide/${master_id}`)
export const toggleHomeNews = (master_id) => request.post(`/news/toggle_home/${master_id}`)
export const toggleCarouselNews = (master_id) => request.post(`/news/toggle_carousel/${master_id}`)

// --- 公告分类管理 ---
export const getNoticeCategoryTree = () => request.get('/notice/category/list')
export const saveNoticeCategory = (data) => request.post('/notice/category/update', data)
export const createNoticeCategory = (data) => request.post('/notice/category', data)
export const deleteNoticeCategory = (data) => request.post('/notice/category/delete', data)
export const updateNoticeCategoryStatus = (data) => request.post('/notice/category/status', data)

// --- 公告内容管理 ---
export const getNoticeList = (params) => request.get('/notice/list', { params })
export const getNoticeDetail = (master_id) => request.get(`/notice/detail/${master_id}`)
export const saveNotice = (data) => request.post('/notice/save', data)
export const deleteNotice = (master_id) => request.post(`/notice/delete/${master_id}`)
export const toggleHomeNotice = (master_id) => request.post(`/notice/toggle_home/${master_id}`)
export const toggleCarouselNotice = (master_id) => request.post(`/notice/toggle_carousel/${master_id}`)
export const toggleHiddenNotice = (master_id) => request.post(`/notice/toggle_hidden/${master_id}`)

// --- 底部菜单管理 ---
export const getFooterMenuList = () => request.get('/footer_menu/list')
export const saveFooterMenu = (data) => request.post('/footer_menu/save', data)
export const deleteFooterMenu = (id) => request.post(`/footer_menu/delete/${id}`)

// -- AI ---
// 翻译内容
export const translateContent = (data) => request.post('/ai/translate', data)


// -- 翻译用字典 --
// 获取所有专有名词字典（不分页）
export const getAllDicts = () => request.get('/dict/all')

// 创建专有名词
export const createDict = (data) => request.post('/dict', data)

// 更新专有名词
export const updateDict = (dictId, data) => request.put(`/dict/${dictId}`, data)

// 删除专有名词
export const deleteDict = (dictId) => request.delete(`/dict/${dictId}`)

// 删除公告某语言
export const deleteNoticeLang = (id) => request.delete(`/notice/lang/${id}`)

// 删除新闻某语言
export const deleteNewsLang = (id) => request.delete(`/news/lang/${id}`)